exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".e7IIb{padding-top:30px}._3kQrd,.e7IIb{margin:0 auto;max-width:1080px}._3kQrd{width:100%;display:block}.A71QK{margin-top:24px}@media screen and (max-width:768px){._3dt9I{padding:0}}", ""]);

// exports
exports.locals = {
	"container": "e7IIb",
	"landingContainer": "_3kQrd",
	"spaceTop4": "A71QK",
	"smPadding": "_3dt9I"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/routes/trustAndVerification/TrustAndVerification.css
// module id = 2654
// module chunks = 15